import React ,{Component } from 'react';
import PatientList from '../views/patientlist';
import { patientActions } from "../../actions";
import { connect } from 'react-redux';

class PatientListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.getData = this.getData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    
        
    }
    componentDidMount(){
        const {dispatch} = this.props;
        dispatch(patientActions.gets(1,10,'','',''));
    }

    getData(page,perPage,sortField,sortOrder,filter)
    {
        const {dispatch} = this.props;
        dispatch(patientActions.gets(page,perPage,sortField,sortOrder,filter));
    }

    deleteData(id)
    {
        const {dispatch} = this.props;
        var result=window.confirm('آیا مطمئن هستید ؟');
        if(result)
        {
            dispatch(patientActions.delete(id,patientActions.gets(1,10,'','','')));
        }
    }
    
    render() { 

        const {list}=this.props;
        console.log('LIST',list);


        return ( 
           <PatientList remoteDataHandler={this.getData} list={list}  deleteHandler={this.deleteData}></PatientList>
         );
    }
}

function mapStateToProps(state) {
    const { objs } = state;
    const { items } = objs;
    //const { queryable } = items;
    return {
        list:items   
        
    };
} 

export default connect(mapStateToProps)(PatientListContainer);